import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_WindowTitle = _resolveComponent("WindowTitle")!
  const _component_Red = _resolveComponent("Red")!
  const _component_WindowContent = _resolveComponent("WindowContent")!
  const _component_Window = _resolveComponent("Window")!

  return (_openBlock(), _createBlock(_component_Window, { class: "dashboard-orbit" }, {
    default: _withCtx(() => [
      _createVNode(_component_WindowTitle, null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Orbit ")
        ])),
        _: 1,
        __: [0]
      }),
      _createVNode(_component_WindowContent, null, {
        default: _withCtx(() => [
          _createElementVNode("table", null, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[2] || (_cache[2] = _createElementVNode("td", null, [
                  _createElementVNode("i", null, "e")
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Red, null, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode("RESTRICTED")
                    ])),
                    _: 1,
                    __: [1]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[4] || (_cache[4] = _createElementVNode("td", null, [
                  _createElementVNode("i", null, "a")
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Red, null, {
                    default: _withCtx(() => _cache[3] || (_cache[3] = [
                      _createTextVNode("RESTRICTED")
                    ])),
                    _: 1,
                    __: [3]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[6] || (_cache[6] = _createElementVNode("td", null, [
                  _createElementVNode("i", null, "i")
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Red, null, {
                    default: _withCtx(() => _cache[5] || (_cache[5] = [
                      _createTextVNode("RESTRICTED")
                    ])),
                    _: 1,
                    __: [5]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[8] || (_cache[8] = _createElementVNode("td", null, " Ω ", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Red, null, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("RESTRICTED")
                    ])),
                    _: 1,
                    __: [7]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[10] || (_cache[10] = _createElementVNode("td", null, [
                  _createElementVNode("i", null, "ω")
                ], -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Red, null, {
                    default: _withCtx(() => _cache[9] || (_cache[9] = [
                      _createTextVNode("RESTRICTED")
                    ])),
                    _: 1,
                    __: [9]
                  })
                ])
              ]),
              _createElementVNode("tr", null, [
                _cache[12] || (_cache[12] = _createElementVNode("td", null, " M ", -1)),
                _createElementVNode("td", null, [
                  _createVNode(_component_Red, null, {
                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                      _createTextVNode("RESTRICTED")
                    ])),
                    _: 1,
                    __: [11]
                  })
                ])
              ])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}